<template lang="pug">
    ModelBasic(:show-left="showForm" :status="status" :error-info="errorInfo"  @download="toDownloadPdf" :download="download", :downloadShow="false" :downloadResource="false" :isCkd="true" :rightTitle="rightTitle")
        template(slot="left-title")
            .form-title(:class="titleClass")
        template(slot="left-content")
            .form-container
                el-form.form(ref="form", :model="model", v-if="model && model.parameters")
                    el-form-item(
                        v-for="(item, index) in model.parameters",
                        :rules="rules[item.name]",
                        :key="`${item.name}_${item.key_type}`",
                        :prop="'parameters.' + index + '.value'")
                        .name {{item.display}}
                        GroupTitle(v-if="item.data_type === 'title'" :title="item.title" :tip="item.tip")
                        //input-radio
                        el-radio-group.item(
                            v-model="item.value",
                            v-else-if="item.ques_type === 'single_choice' && item.show_type === 'select'")
                            el-radio.gzzoc-radio(
                                v-for="(info, i) in item.options",
                                :key='i',
                                :label="info.value") {{info.show_name}}
                        //file
                        el-upload.gzzoc-upload.item(
                            v-model="item.value",
                            v-else-if="item.ques_type === 'file'",
                            action="/api/upl/s3/upload/big/file/unsafe",
                            :show-file-list="false",
                            :ref="item.name"
                            :before-upload="(file) => {return beforeImgUpload(file,item.name)}",
                            :on-success="(res,file,files) => {return uploadsucc(res,file,files,item.name)}",
                            :on-error="(res) => {return handleError(res, item.name)}",
                            :on-progress="() => {return handleProgress(item.name)}")
                            .file-content-wrapper
                                el-button.upload-button(type="primary" :loading="loadingUploadBtn(item.name)") {{$t('gzzoc.upload')}}
                                span.file-name(v-show="upload[item.name]") {{upload[item.name]}}
                        //select
                        el-select.gzzoc-select.item(
                            v-model="item.value",
                            v-else-if="item.ques_type === 'single_choice' && item.show_type === 'pull'")
                            el-option(
                                v-for="(info, i) in item.options",
                                :key='i',
                                :label="info.show_name",
                                :value="info.value")
                        //checkbox
                        el-checkbox-group.item(
                            v-model="item.value",
                            v-else-if="item.ques_type === 'multi_choice'")
                            el-checkbox.gzzoc-checkbox(
                                v-for="(info, i) in item.options",
                                :key='i',
                                :name="item.name",
                                :label="info.value") {{info.show_name}}
                        // date_select
                        el-date-picker.gzzoc-input(
                            type="date"
                            v-model="item.value"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            v-else-if="item.ques_type === 'date_select'")
                        //completion
                        el-input.gzzoc-input.item(
                            type="text",
                            v-model="item.value",
                            v-else-if="item.ques_type === 'completion' && item.data_type === 'number'",
                            :placeholder="$t('gzzoc.numberPlease')")
                        //default
                        el-input.gzzoc-input(
                            type="text",
                            v-model="item.value",
                            v-else,
                            :placeholder="$t('gzzoc.contentPlease')")
                    //- el-form-item
                    //-     GroupTitle(:title="$t('gzzoc.anemiaPhotoTitle')")
                    //- el-form-item
                    //-     .dec {{$t('gzzoc.anemiaRisk1')}}
                    //-     .dec {{$t('gzzoc.anemiaRisk2')}}
                    //- img.zd-img(:src="require('@/assets/imgs/eye-zj.jpg')")

        template(slot="left-footer")
            .form-footer
                el-button.gzzoc-button-primary.submit-btn(type="primary", @click="submit", :disabled="status === 'executing'") {{$t('startAnalysis')}}
                el-button.gzzoc-button-secondary.reset-btn(type="primary" @click="reset") {{$t('reset')}}
        template(slot="right-content")
            .right-content
                .main
                    .item(v-if="result.left_eye_image || result.right_eye_image")
                        .eye
                            img.eye-img(v-if="result.left_eye_image" :src="imgsrc(result.left_eye_image)")
                            img.eye-img(v-if="result.right_eye_image" :src="imgsrc(result.right_eye_image)")
                    .item(v-for="item in result.report")
                        .result.diagnose-advice
                            .title {{$t('gzzoc.KIDS')}}：
                            .detail
                                span.detail-item.has-big-font
                                    span.item-result {{item.result}}    {{item.remark}}
                        // .result.illness-analyse
                        //     .title {{$t('gzzoc.analysis')}}
                        //     .detail
                        //         span.detail-item.has-big-font
                        //             span.item-result {{item.result}}
                        // .result.diagnose-advice
                        //     .title {{$t('gzzoc.diagnosticSuggest')}}
                        //     .detail
                        //         span.detail-item.has-big-font
                        //             span.item-result {{item.remark}}
        template(slot="right-tips")
            .right-tips(v-if="!!modelData && !!modelData['reference_documents'] && modelData['reference_documents'].length != 0")
                .tip-title {{$t('visionomeIntroduction')}}：
                .tip-content(v-html='modelData.model_remark')
                .tip-title {{$t('reference')}}：
                .tip-content {{modelData.reference_documents[0].value}}
                    br
                    a(:href="modelData.reference_documents[1].value", target="_blank") {{modelData.reference_documents[1].value}}
            .right-content-desc(v-if="status === 'success'") {{$t('CKDDes')}}
</template>

<script>
import _ from 'lodash';
import { languages, i18n } from "@/locale";
import Logo from 'components/logo';
import UserNav from 'components/user-nav';
import ModelBasic from './gzzoc-model-basic';
import GroupTitle from '../components/group-title';
import UtilMixins from '@/mixins/utils';
import GzzocModelMixin from './gzzoc-model-mixin';
import ls from '@/utils/local-storage';

export default {
    data () {
        return {
            languages: languages,
            loading: {
                executing: false,
            },
            rightTitle: i18n.t('ckd2Title'),
            lock: [],
            download: {
                loading: false,
                locked: false
            },
            modelData: {
                parameter_list: []
            },
            model: {
                parameters: []
            },
            status: 'not_start',
            errorInfo: '',
            result: {
                value: '',
                explain: '',
                // success、error
                report: null,
                status: ''
            },
            upload: {
                loading_eyelid_images: false,
                loading_nail_image: false,
                status: "",
                right_eye: "",
                left_eye: ""
            },
            imgs: [],
            date: ""
        };
    },
    mixins: [UtilMixins, GzzocModelMixin],
    components: {
        Logo,
        UserNav,
        ModelBasic,
        GroupTitle
    },
    computed: {
        id () {
            return this.$route.params.id;
        },
        lang () {
            return _.find(languages, {lang: this.$i18n.locale}) || languages[0];
        },
        titleClass () {
            let cls = ls.get('lang');
            return {
                'cn': cls === 'zh-CN',
                'en': cls === 'en'
            };
        },
        showForm () {
            return _.get(this.model, 'parameters', []).length > 0;
        },
        rules () {
            return {
                name: [
                    {
                        required: true,
                        trigger: ['change'],
                        message: i18n.t('message.name')
                    }
                ],
                age: [
                    {
                        trigger: ['blur', 'change'],
                        validator (rules, value, callback) {
                            if (value === undefined || value === '' || isFinite(+value)) {
                                callback();
                            } else {
                                callback(new Error('　'));
                            }
                        },
                        message: i18n.t('message.number')
                    },
                    {
                        required: true,
                        trigger: ['change'],
                        message: i18n.t('message.age')
                    }

                ],
                // fundus_image: [
                //     {
                //         required: true,
                //         trigger: ['change'],
                //         message: '请上传图像'
                //     }
                // ],
                title: []
            };
        }
    },
    mounted () {
        this.getData();
    },
    destroyed () {
        clearTimeout(this.timer)
    },
    methods: {
        loadingUploadBtn (key) {
            return this.upload["loading_" + key];
        },
        reset () {
            _.forEach(_.get(this, 'model.parameters', []), model => {
				
                switch (model.ques_type) {
                    case "single_choice": {
                        this.$set(model, 'value', model.default_value);
                        break;
                    }
                    case "multi_choice": {
                        this.$set(model, 'value', model.default_value);
                        break;
                    }
                    default: {
                        this.$set(model, 'value', '');
                        break;
                    }
                }
            });
            this.upload.right_eye = "";
            this.upload.right_eye_image = "";
            this.upload.left_eye = "";
            this.upload.left_eye_image = "";
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        beforeImgUpload (file) {
            const types = ['image/jpeg', 'image/png', 'image/jpg'];
            const size = 5;

            const isJPG = (_.indexOf(types, file.type) > -1);
            const isLt2M = file.size / 1024 / 1024 < size;

            if (!isJPG) {
                this.$message.error(i18n.t('message.imgTypeUnknown'));
            } else if (!isLt2M) {
                this.$message.error(i18n.t('message.imgSizeExceed', { size }));
            }
            return isJPG && isLt2M;
        },
        uploadsucc (res, file, files, key) {
            const id = _.get(file, 'response.value[0]._id');
            const paramList = this.model.parameters;
            this.upload['loading_' + key] = false;
            if (id) {
                const i = _.findIndex(paramList, ['name', key]);
                if(!paramList[i].value) paramList[i].value = []
                paramList[i].value[0] = id
                this.upload[key] = file.name;
                this.upload.status = 'success';
                this.$message.success(i18n.t('message.imgUploadSuccess'));
            } else {
                this.upload.status = 'error';
                this.$message.error(i18n.t('message.imgUploadFail'));
            }
        },
        handleProgress (key) {
            this.upload.status = 'progress';
            this.upload['loading_' + key] = true;
        },
        handleError (res, key) {
            const errorInfo = JSON.parse(res.toString().replace('Error: ', ''));
            const errorMessage = _.get(errorInfo, '_error.detail', '');

            if (errorMessage) {
                this.$message.error(errorMessage);
            }

            this.upload.status = 'error';
            this.upload['loading_' + key] = false;
        },
        submit () {
            this.$refs.form.validate(result => {
                if (!result) {
                    this.$message.error(this.$t('pleaseCheckInput'));
                    return;
                } else if (this.upload.left_eye_image === "" && this.upload.right_eye_image === "") {
                    this.$message.error(i18n.t('message.imgAtLeastAll'));
                    return;
                }
                this.status = 'executing';
                let parameters = this.getParameterValue();
                this.$http.post('mli/predict_model/create_task', {
                    model_id: this.id,
                    parameters
                }).then(resp => {
                    if (_.get(resp, 'body.value.code') !== 0) {
                        let errorInfo = _.get(resp, 'body.value.error');
                        this.status = 'failed';
                        this.$message.error(errorInfo);
                        this.errorInfo = errorInfo;
                        return;
                    }
                    this.task_id = _.get(resp, 'body.value.data.task_id');
                    this.getResult(this.task_id);
                });
            });
        },
        async getData () {
            this.model.parameters = [];
            await this.$http.get('mli/predict_model/model', {
                params: {
                    model_id: this.id
                }
            }).then(resp => {
				
                this.modelData = _.get(resp, 'body.value.data');
                this.model.parameters = this.formatParameters(this.modelData.parameters);
				console.log(this.model.parameters,'cccccccc')
                this.reset();
            });
        },
        getResult (taskId) {
            if (!taskId) {
                this.status = 'not_start';
                return;
            }
            clearTimeout(this.timer);
            this.$http.get('/api/mli/predict_model/task_result', {
                params: {
                    task_id: Array.isArray(taskId) ? taskId.join('|') : taskId
                }
            }).then(resp => {
                if (_.get(resp, 'body.value.code') !== 0) {
                    let errorInfo = _.get(resp, 'body.value.error');
                    this.status = 'failed';
                    this.$message.error(errorInfo);
                    this.errorInfo = errorInfo;
                    return;
                }
                const status = _.get(resp, 'body.value.data.status');
                if (status === 'failed') {
                    let errorInfo = _.get(resp, 'body.value.data.error_info[0]', this.$t('gzzoc.execFailed'));
                    this.status = 'failed';
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        message: errorInfo
                    })
                    this.errorInfo = errorInfo;
                    return;
                } else if (status === 'completed') {
                    const result = _.get(resp, 'body.value.data.results', {});
                    if (result.report[0].status === 0) {
                        let errorInfo = _.get(result.report[0], 'errors');
                        this.status = 'failed';
                        this.$message.error(errorInfo);
                        this.errorInfo = errorInfo;
                    } else {
                        this.result = result;
                        this.status = 'success';
                    }
                    return;
                }
                this.timer = setTimeout(() => {
                    this.getResult(taskId);
                }, 3000);
            });
        },
        toDownloadPdf () {
            let taskId = Array.isArray(this.task_id) ? this.task_id.join('|') : this.task_id;
            this.downloadPdf(taskId, "dprint", this.date, this.download);
        }
    }
};
</script>

<style lang="sass" scoped>
    ::v-deep
        .right-container
            justify-content: inherit
            gap: 16px
            .right-content-wrapper
                .header
                    .title
                        font-family: '微软雅黑'
                        color: #002060
    .form-title
        width: 100%
        height: 48px
        margin-top: 24px
        background-repeat: no-repeat
        &.cn
            background-image: url(~public/images/gzzoc/ckd-cn.svg)
        &.en
            background-image: url(~public/images/gzzoc/ckd-en.svg)

    .form-container
        padding: 20px
        overflow: auto
        flex: 1 1 auto
        width: 400px
        .name
            line-height: 1.4
            font-family: PingFangSC-Regular
            font-size: 14px
            color: #666
            margin-bottom: 10px
            white-space: inherit
            overflow: hidden
            text-overflow: ellipsis
        .dec
            line-height: 1.4
            font-family: PingFangSC-Regular
            font-size: 12px
            color: #666
            margin-bottom: 10px
            white-space: inherit
            overflow: hidden
            text-overflow: ellipsis
        .file-content-wrapper
            display: flex
            align-items: center
            margin-top: 10px
            width: 100%
            .upload-button
                flex: 0 0
                margin-top: 0
            .file-name
                flex: 1 1
                margin-left: 16px
                font-size: 14px
                color: #999
                overflow: hidden
                text-overflow: ellipsis
                white-space: nowrap
                text-align: left
    .right-content-desc
        width: 100%
        text-align: right
        font-size: 12px
        color: #666
        margin-top: 10px
    .form-footer
        padding: 20px 20px
        text-align: center
        height: 90px
        .submit-btn
            width: 232px
            height: 40px
        .reset-btn
            width: 104px
            height: 40px
            margin-left: 16px

    .right-content
        .main
            display: flex
            flex-direction: column
            .item
                flex: 1 1 !important
                &:not(:first-child)
                    margin-left: 24px
                &:not(:last-child)
                    border-bottom: 1px solid #999
                    padding-bottom: 20px
                .eye
                    width: 100%
                    display: flex
                    align-items: center
                    justify-content: center
                    margin-top: 24px
                    .eye-img
                        width: 300px
                        height: 300px
                        background-color: #fff
                        object-fit: scale-down
                    .eye-img:first-child
                        margin-right: 50px
                    .name
                        font-family: PingFangSC-Regular
                        font-size: 14px
                        color: #333
                        text-align: center
                        margin-top: 16px
                .result
                    padding: 16px 0
                    &:not(:last-child)
                        border-bottom: 1px solid #999
                    .title
                        font-family: PingFangSC-Semibold
                        font-size: 14px
                        color: #333
                        height: 20px
                        line-height: 20px
                    .detail
                        width: 100%
                        text-align: center
                        .detail-item
                            display: inline-block
                            line-height: 20px
                            vertical-align: top
                            margin-top: 8px
                            width: 23%
                            margin-right: 2%
                            .item-name
                                font-family: PingFangSC-Regular
                                font-size: 14px
                                color: #666
                            .item-result
                                font-family: PingFangSC-Regular
                                font-size: 14px
                                color: #000
                            &.narrow
                                width: 45%
                                margin-right: 5%
                            &.has-big-font
                                &:first-child
                                    display: block
                                    width: 100%
                                    height: 28px
                                    line-height: 28px
                                    .item-name,
                                    .item-result
                                        font-family: PingFangSC-Semibold
                                        font-size: 20px
                                        color: #000
                                        height: 28px
                                        line-height: 28px
                                        margin-top: 8px
        .footer
            .footer-item
                width: 230px
                position: relative
                left: 100%
                transform: translateX(-100%)
                &:not(:first-child)
                    margin-top: 8px
                .name
                    font-family: PingFangSC-Regular
                    font-size: 14px
                    color: #666
                    line-height: 20px
                    display: inline-block
                    height: 20px
                .value
                    font-family: PingFangSC-Regular
                    font-size: 14px
                    color: #333
                    line-height: 20px
                    display: inline-block
                    height: 20px
            .signature
                .sign
                    display: inline-block
                    width: 154px
                    height: 28px
                    background: url(~public/images/gzzoc/Visionome.png) no-repeat left top / 154px 28px

    .right-tips
        background: none
        padding: 20px 20px 0
        font-size: 12px
        line-height: 1.4
        color: rgba(#fff, .6)
        border-radius: 8px
        .tip-title
            font-family: PingFangSC-Semibold
            font-size: 16px
            line-height: 22px
            color: #333
            letter-spacing: 0.46px
            text-align: justify
            &:not(:first-child)
                margin-top: 16px
        .tip-content
            font-family: PingFangSC-Regular
            font-size: 14px
            line-height: 20px
            color: #333
            letter-spacing: -0.1px
            text-align: justify
            margin-top: 8px
            p
                margin-top: 5px
</style>
